export const CHAT_MESSAGE_TYPE = 'messaging/im';
export const CHAT_MESSAGE_INNER_TYPE = 'CHAT';
export const ACTIVITY_DIRECTION = {
  CUSTOMER_TO_BUSINESS: 'CUSTOMER_TO_BUSINESS',
  BUSINESS_TO_CUSTOMER: 'BUSINESS_TO_CUSTOMER'
};



// WEBPACK FOOTER //
// ./chat-app/constants/chat-message-type.js